import { Grid2, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const DrawerStyled = styled(Grid2)({
  position: 'fixed',
  right: '0',
  top: '15em',
  zIndex: '10',
  backgroundColor: '#1d6fbb',
  border: '1px solid #1d6fbb',
  width: '3em',
  color: '#FFFFFF',
  padding: '5px 0',
  borderRadius: '8px 0 0 8px',
  '&:hover': {
    backgroundColor: '#FFFFFF',
    cursor: 'pointer',
    color: '#1d6fbb',
  },
});

export const VerticalTitleStyled = styled(Typography)({
  writingMode: 'vertical-rl',
  transform: 'rotate(180deg)',
});

export const RotatedImgStyled = styled('img')({
  transform: 'rotate(-90deg)',
});
